module.exports = __webpack_public_path__ + "static/media/beaconHome-1920w.be6f2226.jpg";